import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchCourses } from '../courses/actions';
import Loading from '../common/components/Loading';

class UnlockCourseForm extends Component {
  static PropTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    unlockedCourses: PropTypes.array.isRequired,
  };

  state = {
    selectedCourseId: '',
  };

  componentDidMount() {
    if (!this.props.courses.get('loaded')) {
      this.props.dispatch(fetchCourses());
    }
  }

  onSubmit = e => {
    const { onSubmit, courses } = this.props;
    const { selectedCourseId } = this.state;

    e.preventDefault();

    if (selectedCourseId) {
      onSubmit(
        courses
          .get('data')
          .find(course => course.get('id').toString() === selectedCourseId)
          .toJS()
      );
    }
  };

  onChangeSelectedCourseId = event => {
    this.setState({ selectedCourseId: event.target.value });
  };

  renderCoursesList() {
    const { courses, unlockedCourses } = this.props;
    const options = [];

    courses.get('data').forEach((course, key) => {
      if (!unlockedCourses.find(unlockedCourse => unlockedCourse.id === course.get('id'))) {
        options.push(
          <option value={course.get('id').toString()} key={key}>
            {course.get('name')}
          </option>
        );
      }
    });

    options.unshift(
      <option value="" key="not-selected">
        Choose A Course...
      </option>
    );

    return options;
  }

  render() {
    const { courses, onCancel, loading, unlockedCourses } = this.props;
    const { selectedCourseId } = this.state;

    if (!courses.get('loaded') || loading) {
      return <Loading />;
    }

    return (
      <div>
        <div className="modal__content">
          <div className="input-scaffold">
            {unlockedCourses.length === courses.get('data').size ? (
              <div>There are no courses to unlock</div>
            ) : (
              <select value={selectedCourseId} onChange={this.onChangeSelectedCourseId}>
                {this.renderCoursesList()}
              </select>
            )}
          </div>
        </div>
        <div className="modal__actions">
          <button type="button" className="button button--theme--plain" onClick={onCancel}>
            Cancel
          </button>
          <button className="button" disabled={!selectedCourseId} onClick={this.onSubmit}>
            Submit
          </button>
        </div>
      </div>
    );
  }
}

export default connect((state, ownProps) => ({
  courses: state.courses.courses,
}))(UnlockCourseForm);



// WEBPACK FOOTER //
// ./src/users/UnlockCourseForm.js